import type { AddressFieldNames } from "../../AddressForm/AddressForm.types";

import type { AddressFormValues } from "./AddSpaceAddressForm.schema";

/**
 * Every field name below has to be one this form actually holds — the check the
 * old `cityName: keyof AddressFormValues` props gave, kept at the consumer since
 * the kit itself must stay schema-agnostic.
 */
type AddressFieldsOfThisForm = Record<
  keyof AddressFieldNames,
  keyof AddressFormValues
>;

/**
 * Wire format, not display copy: `AddSpaceAddressForm.submit` branches on
 * `same-as-space`, so these cannot be renamed without changing submit.
 */
const BILLING_CHOICE = {
  SameAsSpace: "same-as-space",
  DifferentAddress: "different-address",
} as const;

/** Ties the submit button in the page footer to the form it submits. */
const ADDRESS_FORM_ID = "address-form";

// The two addresses this form collects, named as `AddSpaceAddressForm.schema` holds
// them. Both point at the same `country`: a host can only list in one country, so
// the form renders a single country field for both addresses.

const SPACE_ADDRESS_FIELDS = {
  city: "spaceCity",
  country: "country",
  postalCode: "spaceZip",
  street: "spaceStreet",
  unit: "spaceUnit",
  zone: "spaceState",
} satisfies AddressFieldsOfThisForm;

const BILLING_ADDRESS_FIELDS = {
  city: "billingCity",
  country: "country",
  postalCode: "billingZip",
  street: "billingStreet",
  unit: "billingUnit",
  zone: "billingState",
} satisfies AddressFieldsOfThisForm;

export {
  ADDRESS_FORM_ID,
  BILLING_ADDRESS_FIELDS,
  BILLING_CHOICE,
  SPACE_ADDRESS_FIELDS,
};
